import React from 'react';
import { useGATrackingForSSR } from '../../utils/gaTracking';
import { useOnClickActionForSSR } from '../../utils/onClickActionForSSR';

import { EnvironmentProvider } from '../../contexts/EnvironmentContext';
import Listing from './components/Listing/Listing';

import { TListingClient } from 'types/TListing';

type TListingAppProps = {
  appState: {
    listing: TListingClient;
  };
  environment: any;
  withTour?: boolean;
};

const ListingApp = ({ appState, environment, withTour }: TListingAppProps) => {
  useGATrackingForSSR();
  useOnClickActionForSSR();

  const { listing } = appState;

  return (
    <EnvironmentProvider value={environment}>
      <Listing listing={listing} withTour={withTour} />
    </EnvironmentProvider>
  );
};

export default ListingApp;
